import { Loader } from "../helpers/actionTypes";

export function loader(loading) {
    return dispatch => { 
      dispatch ({
        type: Loader.LOADER, 
        loading
      }) ;
    };
}